<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0 ml-2">
        Subscription
      </span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!webhookFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            class="text-capitalize"
            style="margin-top: 1px"
            color="primary"
            :disabled="
              !companyReference.is_enabled ||
              loading ||
              (uiCtrl && !uiCtrl.isEnable('btn:::webhook:subscription:create'))
            "
            @click="handleAddWebhook"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่ม Subscription
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :search="search"
      :headers="headers"
      :items="subscriptions"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
      must-sort
    >
      <template v-slot:item.is_receive_real="{ item }">
        <v-chip
          :color="item.is_receive_real ? 'green' : 'error'"
          label
          outlined
          small
        >
          {{ item.is_receive_real ? 'เปิดการใช้งาน' : 'ปิดการใช้งาน' }}
        </v-chip>
      </template>
      <template v-slot:item.is_active="{ item }">
        <div v-if="!companyReference.is_enabled">
          <v-chip color="error" label outlined small>หยุดการส่ง</v-chip>
        </div>
        <div v-else>
          <v-chip
            :color="item.is_active ? 'green' : 'error'"
            label
            outlined
            small
          >
            {{ item.is_active ? 'ปกติ' : 'หยุดการส่ง' }}
          </v-chip>
        </div>
      </template>
      <template v-slot:no-data>NO DATA HERE!</template>
    </v-data-table>
    <WebhookSubscriptionForm
      :formShow="webhookFormShow"
      :formAction="webhookFormAction"
      :webhook="webhook"
      :webhookInit="webhookInit"
      @isWebhookDataChange="handleWebhookFormDataChange"
      @formActionCompleted="handleWebhookFormActionCompleted"
      @onReset="handleWebhookFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="webhookFormShow && webhookFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import WebhookSubscriptionForm from '@/views/webhook/WebhookSubscriptionForm.vue'

export default {
  components: {
    WebhookSubscriptionForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['topic.title'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: false,
      search: '',
      headers: [
        {
          text: 'Topic',
          align: 'start',
          value: 'topic.title',
          width: '25%',
        },
        {
          text: 'Endpoint',
          align: 'start',
          value: 'webhook',
          width: '45%',
        },
        {
          text: 'สถานะ Webhook',
          align: 'start',
          value: 'is_receive_real',
          sortable: false,
          width: '15%',
        },
        {
          text: 'สถานะการส่ง',
          align: 'start',
          value: 'is_active',
          sortable: false,
          width: '15%',
        },
      ],
      webhookFormShow: false,
      webhookFormAction: '',
      webhook: {},
      webhookInit: {},
      isWebhookDataChange: false,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    subscriptions() {
      return this.$store.state.webhook.subscriptions
    },
    companyReference() {
      return this.$store.state.webhook.companyReference
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'Subscription',
        disabled: true,
      },
    ])

    try {
      this.loading = true

      const { company_uuid } = this.$store.state.authentication.company

      await Promise.all([
        this.fetchWebhookTopics(),
        this.fetchWebhookSubscriptions({ company_uuid }),
        this.fetchWebhookCompanyReference({ company_uuid }),
      ])
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions({
      fetchWebhookTopics: 'webhook/fetchWebhookTopics',
      fetchWebhookSubscriptions: 'webhook/fetchWebhookSubscriptions',
      fetchWebhookCompanyReference: 'webhook/fetchWebhookCompanyReference',
    }),
    classRowSelected(row) {
      if (this.webhook.subscription_uuid === row.subscription_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('row:::webhook:subscription:get')
      ) {
        this.dialogForbidden = true
        return
      }

      if (this.webhook.subscription_uuid === row.subscription_uuid) {
        this.webhookFormShow = false
        this.webhookFormAction = ''
        this.webhook = {}
        this.webhookInit = {}
      } else {
        const splitTopic = row.topic?.topic_code.split('.')

        this.webhookFormShow = true
        this.webhookFormAction = 'edit'
        this.webhook = {
          ...row,
          topic_code: 'mastertime.Transaction.New',
          data_transmission_format: splitTopic.includes('Short')
            ? 'mastertime.Transaction.New.Short'
            : 'mastertime.Transaction.New',
          data_transmission_status: splitTopic.includes('Pass')
            ? 'success'
            : splitTopic.includes('Fail')
            ? 'fail'
            : 'all',
          developers: [...row.developers],
        }
        this.webhookInit = {
          ...row,
          topic_code: 'mastertime.Transaction.New',
          data_transmission_format: splitTopic.includes('Short')
            ? 'mastertime.Transaction.New.Short'
            : 'mastertime.Transaction.New',
          data_transmission_status: splitTopic.includes('Pass')
            ? 'success'
            : splitTopic.includes('Fail')
            ? 'fail'
            : 'all',
          developers: [...row.developers],
        }
      }
    },
    handleRowSelected(row) {
      if (this.isWebhookDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddWebhook() {
      this.webhookFormShow = true
      this.webhookFormAction = 'add'
      this.webhook = {
        is_receive_real: true,
        data_transmission_format: 'mastertime.Transaction.New.Short',
        data_transmission_status: 'all',
        developers: [],
      }
      this.webhookInit = {
        is_receive_real: true,
        data_transmission_format: 'mastertime.Transaction.New.Short',
        data_transmission_status: 'all',
        developers: [],
      }
    },
    handleWebhookFormDataChange(value) {
      this.isWebhookDataChange = value
    },
    handleWebhookFormReset(formAction) {
      this.webhook = {}
      this.webhookInit = {}
      this.webhookFormShow = false
      this.webhookFormAction = ''
    },
    handleWebhookFormActionCompleted(formAction) {
      this.webhook = {}
      this.webhookInit = {}
      this.webhookFormShow = false
      this.webhookFormAction = ''
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.webhookFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isWebhookDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
